




































































































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import ConfirmationModal from '@/components/ConfirmationModal.vue'
import QuantityComboBox from '@/components/QuantityComboBox.vue'
const lodash = require('lodash');
import {
  CompanyTypeEnum,
  IVendorPriceListEntry,
  MasterCatalogCollection,
  Par,
  ParCollection,
  PriceList,
  PriceListCollection,
  PriceListEntry
} from 'serverless-firestore'

interface DisplayedPar {
  productName: string,
  category: string,
  parQuantity: number,
  onHandQuantity: number | null,
  priceListEntry: IVendorPriceListEntry,
  quantityType: string,
  location: string,
  suggestedOrderQuantity: number | null
}

@Component({
  components: {
    LoadingPage,
    LabeledValue,
    ConfirmationModal,
    QuantityComboBox
  }
})
export default class ParOrder extends Mixins(IconsMixin, AuthMixin) {
  public isSaving: boolean = false
  public action: 'create' | 'modify' | '' = ''
  public headers = [
    { text: 'Product Name', value: 'productName' },
    { text: 'On-Hand Quantity', value: 'onHandQuantity' },
    { text: 'Par Level', value: 'parQuantity' },
    { text: 'Suggested Order Quantity', value: 'suggestedOrderQuantity' }
  ]
  public pars: Par[] = []
  public displayedPars: DisplayedPar[] = []
  public priceListEntries: IVendorPriceListEntry[] = []
  public priceLists: PriceList[] = []
  public loaded: boolean = false
  public items = Array.from({length: 16}, (_, i) => i)
  public $refs!: {
    form: HTMLFormElement
  }
  public locations:[] = []
  public errors: string[] = []

  public async mounted() {
    await this.populatePriceListEntries()

    const parCollection = new ParCollection(( await this.$firebase ).firestore())
    this.pars = await parCollection.listParsByCompanyId(this.userCompany.id, CompanyTypeEnum.RESTAURANT)

    this.displayedPars = this.pars.reduce((acc, par) => {
      const priceListEntry = this.getPriceListEntry(par.priceListEntryId)
      const productName = priceListEntry && priceListEntry.description ? priceListEntry.description : 'N/A'
      const category = priceListEntry && priceListEntry.category ? priceListEntry.category : 'N/A'

      if (productName === 'N/A') {
        return acc
      }

      return [
        ...acc,
        {
          productName: productName,
          category: category,
          parQuantity: par.quantity,
          onHandQuantity: null,
          priceListEntry: priceListEntry ? priceListEntry : {} as IVendorPriceListEntry,
          quantityType: par.quantityType ? par.quantityType : '',
          location: par.location ? par.location : 'Main Bar',
          suggestedOrderQuantity: null
        }
      ]
    }, [] as DisplayedPar[])

    this.locations = lodash.groupBy(this.displayedPars, "location");
    this.loaded = true;
  }

  public getPriceListEntry(priceListEntryId: string): IVendorPriceListEntry {
    const priceListEntry = this.priceListEntries.find(entry => entry.id === priceListEntryId)
    if (!priceListEntry) {
      console.log('priceListEntry not found: ', priceListEntryId);
      return { id: priceListEntryId, upc: '', description: '', priceListId: '', vendorCompanyId: '' } as IVendorPriceListEntry
    }
    return priceListEntry
  }

  public parSettings() {
    return this.$router.push({ name: 'par-edit' })
  }

  public updateQuantity(item: any, quantity: number) {
    item.onHandQuantity = quantity
  }

  public async buildOrder() {
    if(!this.$refs.form.validate()) {
      if(!this.displayedPars.every(par => par.onHandQuantity === null || (par.onHandQuantity && par.onHandQuantity >= 0))) {
        this.errors.push("Quantity must be greater than or equal to zero for every entry with an on-hand quantity")
      }

      return
    }

    let helperDisplayedPars = this.displayedPars.filter(par => {
      if(par.onHandQuantity !== null){
        if((par.parQuantity - par.onHandQuantity) > 0){
          return par;
        }
      }
    })

    const consolidatedDisplayedPars = helperDisplayedPars.reduce((acc, par) => {
      const duplicate = acc.find(p =>
        p.priceListEntry === par.priceListEntry
        && p.quantityType === par.quantityType
      )

      if (duplicate) {
        if (duplicate.parQuantity && par.parQuantity) {
          duplicate.parQuantity += par.parQuantity
        }

        if (duplicate.onHandQuantity && par.onHandQuantity) {
          duplicate.onHandQuantity += par.onHandQuantity
        }
        return acc
      } else {
        return [...acc, par]
      }
    }, [] as DisplayedPar[])

    await this.$router.push({ name: 'order-edit', params: { data: JSON.stringify(consolidatedDisplayedPars) } })
  }

  private async populatePriceListEntries() {
    const priceListCollection = new PriceListCollection(( await this.$firebase ).firestore())
    this.priceLists = await priceListCollection.listPriceListsByCompanyId(this.userCompany.id, this.userCompany.type, true)

    const masterCatalogCollection = new MasterCatalogCollection(( await this.$firebase ).firestore())

    this.priceLists.forEach(async (priceList: PriceList) => {
      priceList.entries.forEach((entry: PriceListEntry) => {
        this.priceListEntries.push({ ...entry, priceListId: priceList.id, vendorCompanyId: priceList.vendorCompanyId })
      })
      const masterCatalog = await masterCatalogCollection.getByCompanyId(priceList.vendorCompanyId)
      if(masterCatalog && masterCatalog.entries && masterCatalog.entries.length) {
        masterCatalog.entries.forEach((entry: PriceListEntry) => {
          this.priceListEntries.push({ ...entry, priceListId: priceList.id, vendorCompanyId: masterCatalog.companyId })
        })
      }
    })
  }
}
